export default {
  ALLOWED_TAGS: [
    'p',
    'h1',
    'h2',
    'h3',
    'ul',
    'ol',
    'li',
    'strong',
    'em',
    'blockquote',
    'code',
    'pre',
    'img',
    's',
    'strike',
    'a',
  ],
  ALLOWED_ATTR: ['src', 'alt', 'href', 'class', 'target', 'rel'],
};
